import { ApiKey, CreateApiKeyResponse } from '@/models/ApiKeyModels';
import { AuthUser, LoginConfig } from '@/models/AuthModels';

export type State = {
  authUser: AuthUser | null;

  loggedIn: boolean;
  loginConfig: LoginConfig | null;

  apiKeys: Array<ApiKey>;
  createdApiKey: CreateApiKeyResponse | null;
};

export const state: State = {
  // loggedIn: localStorage.getItem("authUser") != null && localStorage.getItem("authUser") !== undefined ? true : false,
  authUser: localStorage.getItem('authUser') != null && localStorage.getItem('authUser') !== undefined ? JSON.parse(localStorage.authUser) : null,

  loggedIn: false,
  loginConfig: localStorage.getItem('loginConfig') != null ? JSON.parse(localStorage.loginConfig) : null,
  apiKeys: [],
  createdApiKey: null,
};
